import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class PurchaseOrderService extends Service {
    constructor() {
        super();
        this.baseURL = 'inventory/purchaseOrder';
    }

    async checkSum5(formData) {
        let url = SERVER_URL + this.baseURL + "/image/upload/check";

        return GeneralUtils.fetchWithAuth(url, {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: formData
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async uploadInvoiceDocument(formData) {
        let url = SERVER_URL + this.baseURL + "/image/upload";

        return GeneralUtils.fetchWithAuth(url, {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: formData
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async telegramRegister() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/telegram/register", {
            crossDomain: true,
            method: 'put',
            headers: {
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async importCsv(id, formData) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/import/csv/id/" + id, {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: formData
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        })
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async downloadCsvSample() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/import/csv/download/sample', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            }
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async approveSupplierAndProcessAgain(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/approveSupplierAndProcessAgain" , {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(data)
        }).then(response => {
                let result = response.clone();
                GeneralUtils.notification(response);
                return GeneralUtils.responseToJson(result);
            }
        ).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findAllOpens() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + '/all/status/OPEN', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            }
        })
            .then(response => response.json())
            .catch(error => {
                GeneralUtils.notification(error);
            });
    }

    async findAllOpensByDescription(orjDescription) {
        const body = {
            orjDescription: orjDescription || null
        };

        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/items/all/status/OPEN", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(body)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response,true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async updateItems(data) {

        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/items", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async revertDuplicateItems(purchaseOrderId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/" + purchaseOrderId + "/revert-duplicates", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async checkConflicts(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/items/check-conflicts", {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async resolveConflictAndUpdate(data, selectedItemId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/items/resolve-conflict?selectedItemId=" + selectedItemId, {
            crossDomain: true,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'X-Softrame-BranchId': localStorage.getItem("merchantBranchId"),
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}